__turbopack_context__.v({
  "cart-slot": "CatalogSearch-module-scss-module__zUy8gq__cart-slot",
  "loading": "CatalogSearch-module-scss-module__zUy8gq__loading",
  "popover-content": "CatalogSearch-module-scss-module__zUy8gq__popover-content",
  "price": "CatalogSearch-module-scss-module__zUy8gq__price",
  "result-info": "CatalogSearch-module-scss-module__zUy8gq__result-info",
  "result-item": "CatalogSearch-module-scss-module__zUy8gq__result-item",
  "result-link": "CatalogSearch-module-scss-module__zUy8gq__result-link",
  "results": "CatalogSearch-module-scss-module__zUy8gq__results",
  "search-anchor": "CatalogSearch-module-scss-module__zUy8gq__search-anchor",
  "search-icon": "CatalogSearch-module-scss-module__zUy8gq__search-icon",
  "spin": "CatalogSearch-module-scss-module__zUy8gq__spin",
  "thumbnail": "CatalogSearch-module-scss-module__zUy8gq__thumbnail",
  "title": "CatalogSearch-module-scss-module__zUy8gq__title",
});
